import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'cv-file',
});

export async function extractCvFile(cvFile, clientApplicationUuid) {
    return backendEndpoint.post('extract', {
        cv: cvFile,
        clientApplicationUuid,
        consent: 1,
    }, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export async function getExtractedCvFile(clientApplicationUuid) {
    return backendEndpoint.get(`extract/${clientApplicationUuid}`);
}
